import 'react-toastify/dist/ReactToastify.css'
// Needed ! See https://github.com/styled-components/styled-components/issues/1593
import 'assets/fonts.css'
import 'logService'

import client from 'apolloClient'
import GlobalStyle from 'assets/GlobalStyle'
import CookieBanner from 'components/CookieBanner'
import ToastContainer from 'components/ToastContainer'
import CartProvider from 'context/Cart'
import CookieBannerProvider from 'context/CookieBanner'
import ModalProvider from 'context/Modal'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { isSubdomain } from 'utils/origin'

const App = ({ ApolloProvider, Router }) => {
  if (null == import.meta.env.VITE_STRIPE_KEY) {
    throw new Error('VITE_STRIPE_KEY is not defined')
  }

  return (
    <>
      { isSubdomain() && (
        <Helmet>
          <meta content="noindex, nofollow"
            name="robots"
          />
          <meta content="noindex"
            name="googlebot"
          />
        </Helmet>
      )}
      <GlobalStyle />
      <ToastContainer />
      <ApolloProvider client={ client }>
        <CookieBannerProvider>
          <ModalProvider>
            <CartProvider>
              <Router />
            </CartProvider>
            <CookieBanner />
          </ModalProvider>
        </CookieBannerProvider>
      </ApolloProvider>
    </>
  )
}

App.propTypes = {
  ApolloProvider: PropTypes.func.isRequired,
  Router: PropTypes.func.isRequired,
}

export default App
